<template>
  <div id="HomeAppliance">
    <div class="section" :class="$mq">
      <div class="title">{{ $t("step2.homeAppliance.title") }}</div>
      <div class="container inline bottom">
        <EnergyButton 
          @click="dishwasher = !dishwasher"
          :active="dishwasher"
          :title="$t('step2.homeAppliance.dishwasher')"
          type="dishwasher"
          :radio="false"
        />
        <EnergyButton 
          @click="dryer = !dryer"
          :active="dryer"
          :title="$t('step2.homeAppliance.dryer')"
          type="dryer"
          :radio="false"
        />
        <EnergyButton 
          @click="washingMachine = !washingMachine"
          :active="washingMachine"
          :title="$t('step2.homeAppliance.washingMachine')"
          type="washingmachine"
          :radio="false"
        />
      </div>
    </div>
  </div>
</template>

<script>
import EnergyButton from "@/components/Energy/EnergyButton.vue";

export default {
  computed: {
    dryer: {
      get() {
        return this.$store.state.consumption.dryer;
      },
      set(value) {
        this.$store.commit("consumption/setDryer", value);
      }
    },
    dishwasher: {
      get() {
        return this.$store.state.consumption.dishwasher;
      },
      set(value) {
        this.$store.commit("consumption/setDishwasher", value);
      }
    },
    washingMachine: {
      get() {
        return this.$store.state.consumption.washingMachine;
      },
      set(value) {
        this.$store.commit("consumption/setWashingMachine", value);
      }
    },
  },
  components:{
    EnergyButton
  }
};
</script>


// WEBPACK FOOTER //
// src/views/consumption/KnowConsumption/HomeAppliance.vue